import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/dashboard/')({
  beforeLoad: async ({ params }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/dashboard/deliverables',
      params: { org: params.org, loopId: params.loopId },
    });
  },
});
